import { Link } from '@mui/material';

import colors from '../../constants/colors';

type PreferenceMessages = {
  success: { [key: string]: { [key: string]: string } };
  error: { [key: string]: string | React.ReactNode };
};

export const PREFERENCE_MESSAGES: PreferenceMessages = {
  success: {
    text: {
      enrolled: 'You have successfully enrolled in policy text message alerts.',
      unenrolled:
        'You have successfully unenrolled in policy text message alerts.',
    },
    paperless: {
      enrolled:
        'You have turned on paperless and will receive email notifications when your documents are available online.',
      unenrolled: 'You have successfully unenrolled in paperless preferences.',
    },
    update: { enrolled: 'You have updated your communication preferences.' },
  },
  error: {
    title: 'We are unable to process your request right now.',
    message: (
      <>
        Please check the details and try again, or contact Service at{' '}
        <Link
          href="tel:+888.980.5650"
          underline="none"
          sx={{
            fontSize: {
              mobile: 16,
              tablet: 18,
            },
            fontWeight: 400,
            fontFamily: 'Cabin',
            color: colors.csaaSpectrumBlue50,
          }}
        >
          888.980.5650
        </Link>
        .
      </>
    ),
  },
};
